export const getFormData = () => ({
    responsibleName: '',
    invoice: '',
    date: '',
    observation: '',
    statusId: 2,
    buyer: {
        name: '',
        document: '',
        birthDate: null,
        phone: '',
        cellPhone: '',
        email: '',
        address: {
            zipCode: '',
            state: '',
            city: '',
            district: '',
            address: '',
            number: '',
            complement: '',
        },
    },
    bovines: [],
    generalValue: {
        typeId: 1,
        value: 0,
        arrobaWeight: 30,
    },
});
